













import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'

  @Component({
    name: 'LineArea',
    components: { Chart }
  })
export default class extends Vue {
    // @Prop({ default: '#00B66C' }) private color!: string
    @Prop({}) private dataList!: any
    private chartId: string = ''
    // private legend: any[] = [{ name: '参考标准', color: '#aeaeae' }, { name: '学员各分值区间占比', color: this.color }]
    private option: any = {
      color: ['#5470C6', '#91CC75'],
      legend: {
        data: ['打卡人次', '打卡率']
      },
      grid: {
        top: 50,
        right: 50,
        left: 50
      },
      tooltip: {
        trigger: 'axis',
        formatter: '{b}<br/>{a0}: {c0}<br />{a1}: {c1}%'
      },
      xAxis: {
        type: 'category',
        data: [],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#999'
          }
        },
        axisLabel: {
          color: '#999'
        }
      },
      yAxis: [
        {
          type: 'value',
          name: '打卡人次',
          min: 0,
          position: 'left',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#999',
            formatter: '{value}'
          }
        },
        {
          type: 'value',
          name: '打卡率',
          min: 0,
          // max: 100,
          position: 'right',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#999',
            formatter: '{value} %'
          }
        }
      ],
      series: [

        {
          name: '打卡人次',
          yAxisIndex: 0,
          data: [],
          type: 'line'
        },
        {
          name: '打卡率',
          yAxisIndex: 1,
          data: [],
          type: 'line'
        }
      ]
    }
    get chart() {
      return this.$refs.chart as any
    }
    @Watch('dataList', { immediate: true, deep: true })
    onDataChange(val: any) {
      if (!this.dataList.length) return
      let names = []
      let data1 = []
      let data2 = []
      this.dataList.map((item: any) => {
        names.push(item.dataTimeStr)
        data1.push(item.clockInPersonYet)
        // data1.push(item.clockInNum)
        data2.push(item.clockInProportionStr)
      })
      this.option.xAxis.data = names
      this.option.series[0].data = data1
      this.option.series[1].data = data2
      this.$nextTick(() => {
        this.chart.update()
      })
    }
    created() {
      this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    }
}
